import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
/** The site owner's photo (Settings → logo): one fetch per page load, shared by the Reels header, the clip byline and story bylines. */
export function useSiteLogo() {
    const [logo, setLogo] = useState(cache);
    useEffect(() => {
        if (cache !== null) { setLogo(cache); return; }
        api.get("/public/settings").then((r) => { cache = r.data?.logo_url || ""; setLogo(cache); }).catch(() => { cache = ""; setLogo(""); });
    }, []);
    return logo || "";
}
